import type { Platform } from '@/types';

export interface PlatformInfo {
  id: Platform;
  name: string;
  shortName: string;
  /** Brand color used for badges/accents */
  color: string;
  /** Tailwind gradient classes for platform tiles */
  gradient: string;
  example: string;
  patterns: RegExp[];
}

export const PLATFORMS: Record<Platform, PlatformInfo> = {
  instagram: {
    id: 'instagram',
    name: 'Instagram',
    shortName: 'Instagram',
    color: '#E1306C',
    gradient: 'from-pink-500 via-rose-500 to-orange-400',
    example: 'https://www.instagram.com/reel/Cxyz.../',
    patterns: [/instagram\.com\/(?:reel|reels|p|tv)\/[\w-]+/i],
  },
};

export const PLATFORM_LIST: PlatformInfo[] = Object.values(PLATFORMS);
